import { render, staticRenderFns } from "./DomainDetails.vue?vue&type=template&id=d668758e&"
import script from "./DomainDetails.vue?vue&type=script&lang=js&"
export * from "./DomainDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports